
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M11.3964 21.3536C11.5917 21.5488 11.9083 21.5488 12.1036 21.3536L15.2855 18.1716C15.4808 17.9763 15.4808 17.6597 15.2855 17.4645C15.0903 17.2692 14.7737 17.2692 14.5784 17.4645L11.75 20.2929L8.92157 17.4645C8.72631 17.2692 8.40973 17.2692 8.21447 17.4645C8.0192 17.6597 8.0192 17.9763 8.21447 18.1716L11.3964 21.3536ZM11.25 3V3.9H12.25V3H11.25ZM11.25 5.7V7.5H12.25V5.7H11.25ZM11.25 9.3V11.1H12.25V9.3H11.25ZM11.25 12.9V14.7H12.25V12.9H11.25ZM11.25 16.5V18.3H12.25V16.5H11.25ZM11.25 20.1V21H12.25V20.1H11.25Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiTextVertical",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
